<template>
  <div class="activity-wrap">
    <app-header />
    <div class="banner_top">
      <div class="banner_main">
        <img
          class="logo_img"
          src="../../assets/images/activity/activity20240117/banner_img.png"
          alt=""
        />
      </div>
    </div>
    <div class="content_main">
      <div class="first_main">
        <div class="main_box">
          <div class="tit_box">
            <img
              class="tit_img"
              src="../../assets/images/activity/activity20240117/first_tit_img.png"
              alt=""
            />
          </div>
          <div class="feature_present_box">
            业内独创的动态行情数据分析技术，以交易所原始Level-2行情为数据基础，经过记忆委托队列、记忆逐笔成交、逐笔成交和委托队列等环节，智能计算出主动成交单、对全部的已成交委托单进行分类汇总、构建决策分析模型。
          </div>
          <div class="contetnt_box">
            <div class="img_box">
              <img src="../../assets/images/activity/activity20240117/dde_first_img.png" alt="">
            </div>
            <!-- <div class="step_box">
              <img src="../../assets/images/activity/activity20240117/dde_one.png" alt="">
            </div> -->
            <!-- <p class="line"></p> -->
            <!-- <div class="img_box two_box">
              <img src="../../assets/images/activity/activity20240117/dde_two_img.png" alt="">
            </div>
            <div class="step_box">
              <img src="../../assets/images/activity/activity20240117/dde_two.png" alt="">
            </div> -->
            <!-- <p class="line"></p>
            <div class="img_box three_box">
              <img src="../../assets/images/activity/activity20240117/dde_three_img.png" alt="">
            </div> -->
            <!-- <div class="step_box three_step" style="height: 530px;">
              <img src="../../assets/images/activity/activity20240117/dde_three.jpg" alt="">
            </div> -->
            <div class="link_box" @click="golink">
                <img src="../../assets/images/activity/activity20240117/dde_link_img.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="ljhy_main">
        <div class="main_box">
          <div class="tit_box">
            <img
              class="tit_img"
              src="../../assets/images/activity/activity20240117/ljhy_tit_img.png"
              alt=""
            />
          </div>
          <div class="feature_present_box">
            六脉神剑是根据<span class="color_text">6大经典指标共振原理</span>研发而成，通过智能演算，形成红绿箭头，辅助投资者研判个股涨跌趋势。
          </div>
          <div class="contetnt_box">
            <div class="img_box_gif">
              <img src="../../assets/images/activity/activity20240117/lmsj_gif.gif" alt="">
            </div>
            <div class="yfy_box">
              <img src="../../assets/images/activity/activity20240117/ljhy_yfy_img.png" alt="">
            </div>
            <p class="line"></p>
            <div class="yfe_box">
              <img src="../../assets/images/activity/activity20240117/ljhy_yfe_img.png" alt="">
            </div>
          </div>
          <div class="btm_img">
            <img src="../../assets/images/activity/activity20240117/ljhy_yfkj.png" alt="">
          </div>
        </div>
      </div>
      <div class="hjk_main">
        <div class="main_box">
          <div class="tit_box">
            <img
              class="tit_img"
              src="../../assets/images/activity/activity20240117/hjk_tit_img.png"
              alt=""
            />
          </div>
          <div class="feature_present_box">
            黄金坑：几乎所有牛股启动之前，都要向下挖坑。因为<span class="color_text">挖坑之后能让该股的筹码更为干净，主力更容易发动行情</span>，所以坑中的筹码显得无比珍贵，股民们形象地把叫它叫作“黄金坑”。
          </div>
          <div class="contetnt_box">
            <div class="img_box_gif">
              <img src="../../assets/images/activity/activity20240117/hjk_gif.png" alt="">
            </div>
            <p class="text_synopsis">黄金坑2.0是基于个股趋势、量价以及成本筹码分析研发而成，当个股出现黄金坑形态时，指标智能发出<span>黄金坑趋势反转信号</span>。</p>
            <div class="affect_box">
              <p>“黄金坑”信号出现后，稳健投资者可等坑填平了、夯实了再重点跟踪，往往更安全、更踏实。</p>
              <p>功能入口：「大智慧365」收费版用户在软件内打开任意个股K线，搜索“黄金坑”或首字母“HJK”回车确认后，即可在幅图指标查看“黄金坑”指标信号</p>
            </div>
            <div class="link_btn" @click="golink">
              <img src="../../assets/images/activity/activity20240117/hjk_link_btn.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="level_main">
        <div class="main_box">
          <div class="tit_box">
            <img class="tit_img" src="../../assets/images/activity/activity20240117/level2_tit_img.png" alt="" />
          </div>
          <div class="feature_present_box">
            <p>Level-2深度行情数据是普通行情数据的升级版，具有极大的信息含金量，基本是目前各类券商和研究机构的必备数据。</p>
            <p>大智慧作为沪深交易所首批授权发布Level-2行情数据的机构，对Level-2行情数据的深层次分析和应用始终处于行业领先水平。</p>
          </div>
          <div class="contetnt_box">
            <p class="tit_text_box">行情五档升千档，看清主力隐藏挂单和真实意图</p>
            <p class="text_present_box">Level-2行情用户打开任意沪深个股，可轻松看到<span>全部委托挂单情况（免费行情只能看买1到买5、卖1到卖5），哪个价位有大笔挂单，一目了然。</span></p>
            <p class="text_present_bg_box">只有看到5档之外的盘口，才能看到主力隐藏的挂单和真实意图，真正做到与主力共进退。</p>
            <div class="img_box">
              <img src="../../assets/images/activity/activity20240117/level2_one_img.png" alt="">
            </div>
          </div>
          <div class="contetnt_box box_two">
            <p class="tit_text_box">查看逐笔成交明细，主力买卖单无所遁形</p>
            <p class="text_present_box"><span>免费用户</span>的分时成交数据每<span>3秒合并打包一次</span>，推送给用户，投资者不能查看这3秒内真实交易情况。3秒内主力大单与散户小单的成交数据合并成一个数据后，投资者发现不了是否有主力买入或卖出。</p>
            <p class="text_present_box"><span>Level-2行情</span>不仅速度快，还会<span>把每一笔成交都展示出来</span>，投资者<span>根据成交单的大小或成交单数是否有规律</span>， 便可以<span>判断出成交单是机构、大户、还是散户所为</span>，主力买卖单无所遁形。</p>
            <div class="img_box">
              <img src="../../assets/images/activity/activity20240117/level2_two_img.png" alt="">
            </div>
          </div>
          <div class="contetnt_box box_three">
            <p class="tit_text_box">龙虎看盘：实时追踪成交单中主力/散户资金占比</p>
            <p class="text_present_box">实时动态展示当前成交单中特大单、大单、中单、小单占比，投资者可<span>根据买单/卖单中大单、特大单占比，研判股价涨跌是否为主力大资金行为</span>，进而紧跟主力大资金步伐。</p>
            <div class="img_box">
              <img src="../../assets/images/activity/activity20240117/level2_three_img.png" alt="">
            </div>
            <div class="affect_box">
              <p>功能入口：在分时图下点击小窗口下的“龙”字可调出龙虎看盘功能，或运用页面设计功能，在盘口处点击右键，从显示项目列表中将“龙虎看盘”放在需要的窗口中。</p>
            </div>
          </div>
          <div class="link_box" @click="golink">
            <img src="../../assets/images/activity/activity20240117/level2_link_img.png" alt="">
          </div>
        </div>
      </div>
      <div class="hxtq_main">
        <div class="main_box">
          <div class="tit_box">
            <img
              class="tit_img"
              src="../../assets/images/activity/activity20240117/dzhsfb_tit_img.png"
              alt=""
            />
          </div>
          <div class="contetnt_box">
            <ul>
              <li v-for="(item,index) in hxtqList" :key="index">
                <span>{{ item.name }}</span>
                <span>{{ item.text }}</span>
              </li>
            </ul>
            <!-- <p class="tit_text_box">行情五档升千档，看清主力隐藏挂单和真实意图</p>
            <p class="text_present_box">Level-2行情用户打开任意沪深个股，可轻松看到<span>全部委托挂单情况（免费行情只能看买1到买5、卖1到卖5），哪个价位有大笔挂单，一目了然。</span></p>
            <p class="text_present_bg_box">只有看到5档之外的盘口，才能看到主力隐藏的挂单和真实意图，真正做到与主力共进退。</p>
            <div class="img_box">
              <img src="../../assets/images/activity/activity20240117/level2_one_img.png" alt="">
            </div> -->
          </div>
          <div class="motto_box">
            <p>要在投资中超过别人必须要“用好的工具，有领先的思想，有大的智慧”</p>
            <p>——华尔街策略大师：安迪·凯思勒</p>
          </div>
          <p class="first_risk_warning">风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；所有工具都有</p>
          <p class="last_risk_warning">局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险。</p>
        </div>
      </div>
    </div>
    <!-- foodShow -->
    <div :class="nav_show ? 'footer_box' : 'footer_box'">
      <div class="footer_content">
        <div class="main_footer">
          <img src="../../assets/images/activity/activity20240117/mskt_link_btn.png" @click="golink"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader
  },
  data() {
    return {
      token: "",
      hxtqList:[
        {name:"DDE决策",text:"3分钟高效锁定强势股"},
        {name:"SV资金流",text:"实时跟踪控盘资金动向"},
        {name:"超级Level-2",text:"行情5档升千档"},
        {name:"四维战法",text:"AI决策，揭示变盘信号"},
        {name:"六脉神剑",text:"六剑出鞘，股海擒牛"},
        {name:"分时博弈",text:"分时监控各类资金趋势"},
        {name:"黄金坑",text:"捕捉趋势反转信号"},
        {name:"复盘神器",text:"洞悉市场热点风向"},
        {name:"波段线",text:"挖掘波段投资机会"},
        {name:"股东深度挖掘",text:"洞察股东结构异动"},
        {name:"九转交易",text:"抄底/逃顶利器"},
        {name:"短仓波动",text:"揭露短线资金攻击力度"},
      ],
      nav_show: false,
      s: this.$route.query.s
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
    if(!this.s){
      this.s = "";
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll:function(){
      let scrollTop = document.documentElement.scrollTop;
      // 当页面滑动的距离大于300px时元素显示，否则不显示
      if (scrollTop >= 4200) {
        this.nav_show = true;
        // setTimeout(function(){
          document.querySelector('.footer_box').style.opacity = 1;
        // },450)
      } else {
        this.nav_show = false;
        document.querySelector('.footer_box').style.opacity = 0;
      }
    },
    golink:function(){
      // window.location.href = "https://pay.dzh.com.cn/pay-mall/order/confirm/116/12?s=" + this.s;
      this.$router.push("/order/confirm/116/12?s=" + this.s);
    }
  }
};
</script>
<style lang="scss" scoped>
// 清除浮动
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.activity-wrap {
  background: #f7f7f7;
  overflow: hidden;
  overflow: hidden;
  .banner_top {
    width: 100%;
    background: url("../../assets/images/activity/activity20240117/header.png")
      no-repeat center top;
    background-size: 100% 735px;
    position: relative;
    height: 735px;
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;

    .banner_main {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .logo_img {
        width: 100%;
        height: 730px;
        top: 0;
        left: 0;
      }
    }
  }
  .content_main {
    width: 100%;
    .first_main {
      width: 100%;
      background: url("../../assets/images/activity/activity20240117/first_main_bg.png")
        no-repeat center top;
      background-size: 100% 100%;
      .main_box {
        width: 1200px;
        padding: 84px 0 121px 0;
        box-sizing: border-box;
        margin: 0 auto;

        .tit_box {
          width: 100%;
          text-align: center;
          margin-bottom: 20px;
          .tit_img {
            width: 922px;
            height: 98px;
          }
        }
        .contetnt_box{
          background: url("../../assets/images/activity/activity20240117/first_content_bg.png") no-repeat center top;
          background-size: 100% 100%;
          padding: 64px 17px 87px;
          box-sizing: border-box;
          position: relative;
          .img_box{
            width: 910px;
            height: 578px;
            margin: 0 auto;
            margin-bottom: 24px;
            &.two_box{
              height: 517px;
            }
            &.three_box{
              height: 679px;
            }
            img{
              width: 100%;
              height: 100%;
            }
            
          }
          .step_box{
            width: 1028px;
            height: 117px;
            margin: 0 auto;
            margin-bottom: 41px;
            &.three_step{
              height: 172px;
            }
            img{
              width: 100%;
              height: 100%;
            }
          }
          .line{
            width: 100%;
            height: 1px;
            background-color: #e7e7e7;
            margin-bottom: 41px;
          }
          .link_box{
            width: 902px;
            height: 113px;
            position: absolute;
            bottom: -57px;
            cursor: pointer;
            left: calc( 50% - 451px );
            animation-name: likes; // 动画名称
            animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
            animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
            animation-delay: 0s; // 动画延迟时间
            animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
            animation-duration: 1s; // 动画完成时间
          }
        }
      }
    }
    .ljhy_main{
      width: 100%;
      background: url("../../assets/images/activity/activity20240117/ljhy_bg.png") no-repeat center top;
      background-size: 100% 100%;
      .main_box{
        width: 1200px;
        padding: 103px 0 130px 0;
        box-sizing: border-box;
        margin: 0 auto;
        .tit_box {
          width: 100%;
          text-align: center;
          margin-bottom: 20px;
          .tit_img {
            width: 855px;
            height: 98px;
          }
        }
        .contetnt_box{
          background: url("../../assets/images/activity/activity20240117/ljhy_content_bg.png") no-repeat center top;
          background-size: 100% 100%;
          padding: 54px 17px 49px;
          margin-bottom: 53px;
          box-sizing: border-box;
          position: relative;
          .img_box_gif{
            width: 1000px;
            height: 605px;
            margin: 0 auto;
            box-sizing: border-box;
            margin-bottom: 36px;
          }
          .yfy_box{
            width: 1028px;
            height: 269px;
            margin: 0 auto;
          }
          .line{
            width: 100%;
            height: 1px;
            background-color: #e7e7e7;
            margin: 40px 0;
          }
          .yfe_box{
            width: 1028px;
            height: 184px;
            margin: 0 auto;
          }
        }
        .btm_img{
          width: 1002px;
          height: 197px;
          margin: 0 auto;
        }
      }
    }
    .hjk_main{
      width: 100%;
      background: url("../../assets/images/activity/activity20240117/hjk_bg.png")
        no-repeat center top;
      background-size: 100% 100%;
      .main_box{
        width: 1200px;
        padding: 103px 0 130px 0;
        box-sizing: border-box;
        margin: 0 auto;
        .tit_box {
          width: 100%;
          text-align: center;
          margin-bottom: 20px;
          .tit_img {
            width: 927px;
            height: 98px;
          }
        }
        .contetnt_box{
          background: url("../../assets/images/activity/activity20240117/ljhy_content_bg1.png") no-repeat center top;
          background-size: 100% 100%;
          padding: 54px 17px 98px;
          margin-bottom: 53px;
          box-sizing: border-box;
          position: relative;
          .img_box_gif{
            width: 1055px;
            height: 725px;
            margin: 0 auto;
            box-sizing: border-box;
            margin-bottom: 36px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .text_synopsis{
            font-size: 24px;
            line-height: 32px;
	          letter-spacing: 1px;
	          color: #010101;
            width: 1037px;
            margin: 0 auto;
            margin-bottom: 35px;
            span{
              color: #d30507;
            }
          }
          .affect_box{
            width: 1070px;
            padding: 28px 16px;
            background-color: #e5e5e5;
            box-sizing: border-box;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: 1px;
            color: #555555;
            margin: 0 auto;
            position: relative;
            &::before{
              content: " ";
              position: absolute;
              top: -30px;
              left: 0px;
              border-top:  15px solid transparent;
              border-bottom: 15px solid #e5e5e5;
              border-right:  15px solid transparent;
            }
            p{
              position: relative;
              padding-left: 33px;
              &:first-child{
                margin-bottom: 10px;
                &::before{
                  content:"1、";
                  position: absolute;
                  left: 10px;
                }
              }
              &:last-child::before{
                content:"2、";
                position: absolute;
                left: 10px;
              }
            }
          }
          .link_btn{
            width: 902px;
            height: 113px;
            position: absolute;
            bottom: -56px;
            left: calc( 50% - 451px );
            cursor: pointer;
            animation-name: likes; // 动画名称
            animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
            animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
            animation-delay: 0s; // 动画延迟时间
            animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
            animation-duration: 1s; // 动画完成时间
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .level_main{
      width: 100%;
      background: url("../../assets/images/activity/activity20240117/level2_bg.png")
        no-repeat center top;
      background-size: 100% 100%;
      .main_box{
        width: 1200px;
        padding: 83px 0 105px 0;
        box-sizing: border-box;
        margin: 0 auto;
        .tit_box {
          width: 100%;
          text-align: center;
          margin-bottom: 20px;
          .tit_img {
            width: 1196px;
            height: 98px;
          }
        }
        .feature_present_box{
          &::before{
          position: absolute;
          top: 122px;
          left: 48px;
          content: " ";
          border-top: 7.5px solid transparent;
          border-left: 15px solid #df0015;
          border-bottom: 7.5px solid transparent;
        }
        }
        .contetnt_box{
          background: url("../../assets/images/activity/activity20240117/ljhy_content_bg.png") no-repeat center top;
          background-size: 100% 100%;
          padding: 57px 26px 68px;
          margin-bottom: 58px;
          box-sizing: border-box;
          &.box_two{
            padding-bottom: 43px;
            .img_box{
              width: 1080px;
              height: 540px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
          &.box_three{
            padding-bottom: 43px;
            .img_box{
              width: 1025px;
              height: 680px;
              margin-bottom: 37px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .affect_box{
            width: 1070px;
            padding: 28px 16px;
            background-color: #e5e5e5;
            box-sizing: border-box;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: 1px;
            color: #555555;
            margin: 0 auto;
            position: relative;
            &::before{
              content: " ";
              position: absolute;
              top: -30px;
              left: 0px;
              border-top:  15px solid transparent;
              border-bottom: 15px solid #e5e5e5;
              border-right:  15px solid transparent;
            }
          }
          }
          .tit_text_box{
            width: 100%;
            font-size: 30px;
            font-weight: bold;
            line-height: 32px;
            color: #303030;
            text-align: center;
            padding-bottom: 16px;
            box-sizing: border-box;
            border-bottom: 1px solid #b1b1b1;
            position: relative;
            margin-bottom: 30px;
            &::before{
              content: " ";
              position: absolute;
              bottom: -18px;
              left: calc( 50% - 7.5px );
              border-top:  10px solid #b1b1b1;
              border-bottom: 7.5px solid transparent;
              border-right:  7.5px solid transparent;
              border-left:  7.5px solid transparent;
            }
          }
          .text_present_box{
            font-size: 23px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: 1px;
            color: #303030;
            margin-bottom: 17px;
            span{
              color: #c80114;
            }
          }
          .text_present_bg_box{
            width: 1008px;
	          height: 51px;
            line-height: 51px;
            text-align: center;
            font-size: 23px;
            color: #ffffff;
            margin: 0 auto;
            background-color: #cb1214;
            box-shadow: 0px 2px 10px 0px rgba(186, 0, 18, 0.23);
            border-radius: 8px;
            margin-bottom: 22px;
          }
          .img_box{
            width: 1006px;
            height: 868px;
            margin: 0 auto;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
        .link_box{
          width: 902px;
          height: 115px;
          margin: 0 auto;
          cursor: pointer;
          animation-name: likes; // 动画名称
          animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
          animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
          animation-delay: 0s; // 动画延迟时间
          animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
          animation-duration: 1s; // 动画完成时间
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .hxtq_main{
      width: 100%;
      background: url("../../assets/images/activity/activity20240117/hxtq_bg.png")
        no-repeat center top;
      background-size: 100% 100%;
      .main_box{
        width: 1200px;
        padding: 103px 0 264px 0;
        box-sizing: border-box;
        margin: 0 auto;
        .tit_box {
          width: 100%;
          text-align: center;
          margin-bottom: 47px;
          .tit_img {
            width: 936px;
            height: 98px;
          }
        }
        .contetnt_box{
          background: url("../../assets/images/activity/activity20240117/ljhy_content_bg1.png") no-repeat center top;
          background-size: 100% 100%;
          padding: 70px 63px 58px;
          margin-bottom: 82px;
          box-sizing: border-box;
          width: 1118px;
          margin: 0 auto;
          margin-bottom: 82px;
          ul{
            display: flex;
            flex-wrap: wrap;
            li{
              display: inline-block;
              width: 470px;
              height: 80px;
              border-radius: 4px;
              border: 2px dashed #3d3d3d;
              margin-bottom: 33px;
              padding-bottom: 28px;
              padding-left: 32px;
              box-sizing: border-box;
              display: flex;
              align-items: flex-end;
              &:nth-child(odd){
                margin-right: 50px;
              }
              &:nth-child(11),
              &:nth-child(12){
                margin-bottom: 0px;
              }
              span{
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                &:last-child{
                  font-size: 23px;
                  color: #333333;
                  margin-left: 22px;
                  font-weight: 500;
                }
              }
            }
          }
        }
        .motto_box{
          width: 861px;
          height: 138px;
          background-color: #ffffff;
          box-shadow: 0px 2px 2px 0px #fecc39;
          border-radius: 8px;
          box-sizing: border-box;
          margin: 0 auto;
          padding: 38px 27px;
          margin-bottom: 73px;
          p{
            font-size: 23px;
            color: #333333;
            line-height: 40px;
            &:last-child{
              text-align: right;
            }
          }
        }
        .first_risk_warning{
          font-size: 12px;
          line-height: 18px;
          color: #9c9c9c;
          text-align: center;
        }
        .last_risk_warning{
          font-size: 12px;
          line-height: 18px;
          color: #9c9c9c;
          text-align: center;
        }
      }
    }
  }
  .footer_box {
    width: 100%;
    height: 69px;
    background-color: #e9e9e9;
    border-style: solid;
    border-width: 2px;
    border-image-source: linear-gradient(0deg,  #ffffff 0%,  #ff0000 100%);
    border-image-slice: 1;
    position: fixed;
    left: 0;
    bottom: 0;
    opacity: 0;
    .footer_content{
      width: 100%;
      height: 100%;
      position: relative;
      .main_footer{
        width: 1268px;
        height: 160px;
        background: url("../../assets/images/activity/activity20240117/foot_img.png")
        no-repeat center top;
        background-size: 100% 100%;
        position: absolute;
        top: -87px;
        left: calc(50% - 634px);
        padding: 24px 0 0 798px;
        box-sizing: border-box;
        img{
          width: 336px;
          height: 103px;
          cursor: pointer;
          animation-name: likes; // 动画名称
          animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
          animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
          animation-delay: 0s; // 动画延迟时间
          animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
          animation-duration: 1s; // 动画完成时间
        }
      }
    }
  }
}


.feature_present_box {
  width: 1000px;
  margin: 0 auto;
  margin-bottom: 45px;
  background: url("../../assets/images/activity/activity20240117/feature_present_img.png")
    no-repeat center top;
  background-size: 100% 100%;
  padding: 48px 48px 48px 41px;
  box-sizing: border-box;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
  color: #303030;
  text-indent: 30px;
  position: relative;
  &::after{
    position: absolute;
    top: 57px;
    left: 48px;
    content: " ";
    border-top: 7.5px solid transparent;
    border-left: 15px solid #df0015;
    border-bottom: 7.5px solid transparent;
  }
  .color_text{
    color: #d50513;
  }
}

.foodShow{
  animation: blurAppear 0.5s;
}
.foodShowNot{
  animation: blurAppearNot 0.5s;
}
@keyframes likes {
	0%{
	    transform: scale(1);
	 }
	25%{
	   transform: scale(0.9);
	}
	50%{
	   transform: scale(0.85);
	}
	75%{
	   transform: scale(0.9);
	}
	100%{
	   transform: scale(1);
	}
}

@keyframes blurAppear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes blurAppearNot {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity20240117.vue